export default {"src":"/_next/static/media/quotation.8b932d20.svg","height":30,"width":38,"blurWidth":0,"blurHeight":0};